import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import type { HotelReservationPageProps } from "@b2bportal/core-hotels";
import {
  TripsRawEventName,
  useEmitCoreTripsRawEvent,
} from "@b2bportal/core-trips";

export const useHotelReservationPage = (
  context: HotelReservationPageProps["context"]
) => {
  const reservation = context.hotelReservation?.reservation;
  const itinerary = context.hotelReservation;

  const navigate = useNavigate();

  const emitViewedEvent = useEmitCoreTripsRawEvent(
    TripsRawEventName.ViewedTripSummaryHotel
  );
  useEffect(() => {
    if (!context.isLoading && context.hotelReservation != null) {
      emitViewedEvent();
    }
  }, [context.isLoading, context.hotelReservation, emitViewedEvent]);

  const isLoading =
    context.isLoading || itinerary == null || reservation == null;

  const onQueryCancellation = useCallback(() => {
    navigate("cancel");
  }, [navigate]);

  return {
    reservation,
    itinerary,
    isLoading,
    onQueryCancellation,
  };
};
